module.exports = __webpack_public_path__ + "img/zuzhi.9d8545f9.png.aef9a49e.png";